import React, { useContext, useEffect, useState } from 'react'
import { Label, Select, SelectOption, Alert } from '@americanexpress/dls-react'
import userContext from '../../components/ContextComponent/UserContext';

function NameOnCard() {
    const { formData, setFormData } = useContext(userContext);
    const { errorData, setErrorData } = useContext(userContext);
    const [nameOnCardList, setNameOnCardList] = useState([]);
    
    useEffect(() => {
        let arrNameOnCard = [];
        if (formData.firstName !== '') {
            if (formData.middleName !== '') {
                arrNameOnCard.push(
                    formData.firstName.toUpperCase() + ' ' + formData.middleName.toUpperCase() + ' ' + formData.lastName.toUpperCase(),
                    formData.firstName.toUpperCase() + ' ' + formData.middleName.charAt(0).toUpperCase() + ' ' + formData.lastName.toUpperCase(),
                    formData.firstName.charAt(0).toUpperCase() + ' ' + formData.middleName.charAt(0).toUpperCase() + ' ' + formData.lastName.toUpperCase(),
                    formData.firstName.charAt(0).toUpperCase() + ' ' + formData.middleName.toUpperCase() + ' ' + formData.lastName.toUpperCase(),
                    formData.firstName.toUpperCase() + ' ' + formData.middleName.charAt(0).toUpperCase() + ' ' + formData.lastName.charAt(0).toUpperCase(),
                );
            }
            arrNameOnCard.push(
                formData.firstName.toUpperCase() + ' ' + formData.lastName.toUpperCase(),
                formData.firstName.charAt(0).toUpperCase() + ' ' + formData.lastName.toUpperCase(),
                formData.firstName.toUpperCase() + ' ' + formData.lastName.charAt(0).toUpperCase(),
                formData.firstName.toUpperCase()
            );
            var arrLength = arrNameOnCard.length;
            while (arrLength--) {
                if (arrNameOnCard[arrLength].length > 17)
                    arrNameOnCard.splice(arrLength, 1);
            }
            //filter duplicate  elements:
            let arrUniqueNameOnCard = [...new Set(arrNameOnCard)];
            setNameOnCardList(arrUniqueNameOnCard);
        }
    }, [formData]);

    const onChangeHandle = (event) => {
        if (event.target.value === '')
            setErrorData({ ...errorData, nameOnCardRequired: true });
        else {
            setErrorData({ ...errorData, nameOnCardRequired: false });
            setFormData({ ...formData, nameOnCard: event.target.selectedOptions[0].text });
        }
    };

    return (
        <div>
            <Label className="label-1" htmlFor="smartfield">Name on Card</Label>
            <Select id="nameOnCard" fluid={true} name="NameOnCard" aria-describedby="NameOnCard-alert" required={true} onChange={onChangeHandle}>
                <SelectOption value="">Select</SelectOption>
                {nameOnCardList.map((name, i) => (
                    <SelectOption value={i} key={i}>{name}</SelectOption>
                ))}
            </Select>
            <Alert id="NameOnCard-alert" show={errorData.nameOnCardRequired}>Please make a selection.</Alert>
        </div>
    );
}
export default NameOnCard;